import { Component, Input, OnInit, inject } from "@angular/core";
import {
    EffectivenessModel,
    EffectivenessSourceDocumentsModel,
    WorkflowStepPermissionModel,
} from "../../../shared/models";
import { SampleGenerationType, SampleType } from "../../../shared/enums";
import { AdvEffDataService } from "../../../shared/services";
import { ExcelHelper } from "@app/shared/helpers/excel-helper";
import { ControlExecutionOverviewModel } from "@app/controls/models/control-execution/control-execution-overview-model";
import { MatDialog } from "@angular/material/dialog";
import { SourcesPopulationPopupComponent } from "../../status-components/popups/sources-population-popup/sources-population-popup.component";
import { EffectivenessStatusType } from "../../../shared/enums";
import { DocumentManagerService } from "../../common/services/document-manager.service";
import { ToastrService } from "ngx-toastr";
import { EffExpansionPanelComponent } from "../../common/eff-expansion-panel/eff-expansion-panel.component";
import { DocumentsListComponent } from "../../status-components/components/documents-list/documents-list.component";
import { EffIconComponent } from "../../common/eff-icon/eff-icon.component";
import { TranslatePipe, injectTranslation, provideTranslationScope } from "@app/shared/i18n/translation-scope";
import { scope } from "@app/controls/i18n/scope";

@Component({
    selector: "eff-source-document-info-box",
    templateUrl: "./eff-source-document-info-box.component.html",
    styleUrls: ["./eff-source-document-info-box.component.scss"],
    viewProviders: [provideTranslationScope(scope)],
    imports: [TranslatePipe, EffExpansionPanelComponent, DocumentsListComponent, EffIconComponent]
})
export class EffSourceDocumentInfoBoxComponent implements OnInit {
    private _ds = inject(AdvEffDataService);
    private _dialog = inject(MatDialog);
    private _documentManager = inject(DocumentManagerService);
    private _toastr = inject(ToastrService);
    private _translation = injectTranslation(scope);

    @Input() isCollapsed = false;
    @Input() effectivenessModel: EffectivenessModel;
    @Input() stepPermissions: WorkflowStepPermissionModel;
    @Input() panelOpenState: boolean = false;

    executionData: ControlExecutionOverviewModel[] = [];
    sourceDocumentModel: EffectivenessSourceDocumentsModel;
    sampleGenerationType = SampleGenerationType;
    columnId: string;
    rowsToSkip: number;
    isNonOccurrenceTestPlan = false;

    ngOnInit(): void {
        this.loadData();
    }

    loadData() {
        if (this.effectivenessModel.guid && !this.sourceDocumentModel) {
            this._ds.getSourceDocuments(this.effectivenessModel.guid).subscribe((data) => {
                this.sourceDocumentModel = data;
                if (this.isSpreadSheet()) {
                    const columnName = ExcelHelper.convertNumberToExcelColumn(
                        this.sourceDocumentModel.idColumn,
                    );

                    this.columnId = columnName;
                    this.rowsToSkip = this.sourceDocumentModel.rowsToSkip;
                }
            });
        }
        this._ds.getExecutionOverview(this.effectivenessModel.guid).subscribe((data) => {
            this.executionData = data;
        });
        this.isNonOccurrenceTestPlan =
            this.effectivenessModel.status == EffectivenessStatusType.nonOccurrence ||
            this.effectivenessModel.status == EffectivenessStatusType.nonOccurrenceCompleted ||
            this.effectivenessModel.status == EffectivenessStatusType.reviewNonOccurrence;
    }

    isSpreadSheet() {
        return this.effectivenessModel.sampleType == SampleType.spreadsheet;
    }

    async openPopup(): Promise<void> {
        await this._translation.ready();
        this._dialog.open(SourcesPopulationPopupComponent, {
            data: {
                title: this._translation.t("effSourceDocumentInfoBox.overviewTitle"),
                executionData: this.executionData,
            },
            panelClass: "eff-popup-wrapper",
            width: "70%",
            height: "75%",
        });
    }

    async downloadSampledPopulation(): Promise<void> {
        const sourceDocCount = this.sourceDocumentModel.documents.length;

        if (sourceDocCount === 0) {
            await this._translation.ready();
            this._toastr.error(this._translation.t("effSourceDocumentInfoBox.sourceDocumentNotAvailable"));
            return;
        }

        const lastDocument = this.sourceDocumentModel.documents[sourceDocCount - 1];
        this._documentManager.downloadDocument(lastDocument);
    }
}
